<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="活动名称" name="name"></c-form-item>
					<c-form-item type="checkbox"  name="start_state" :options="activityState"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="stateName"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_global_reward_edit" color="sys" @click="navigateTo('/global_reward_add')">新建全场满赠满减</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="启禁用状态"
					name="state"
					width="85"
				>
				  <template v-slot="{data}">
					<span v-if="data.state == 1" style="color:red">禁用</span>
					<span v-if="data.state == 2" style="color:green">启用</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="状态"
					name="start_state"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 1" >--</span>
						<span v-if="data.state == 2 && data.start_state == 0" style="color:#999">未开始</span>
						<span v-if="data.state == 2 && data.start_state == 1" style="color:dodgerblue">进行中</span>
						<span v-if="data.state == 2 && data.start_state == 2" style="color:#999">已结束</span>
					</template>
				</c-table-column>

				<c-table-column
					label="活动名称"
					name="name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="活动类型"
					name="type"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.type == 1" style="color:dodgerblue">满减</span>
						<span v-if="data.type == 2" style="color:green">满赠</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="门槛及奖励规则"
					width="200"
				>
					<template v-slot="{data}">
						<span>订单</span>
						<span v-if="data.kinds == 1">每</span>
						<span v-if="data.type == 1">满{{data.reward_order_product_money}}减{{data.reduce_money}}</span>
						<span v-if="data.type == 2">满{{data.reward_order_product_money}}送赠品</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="是否叠加"
					name="kinds"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.kinds == 1">叠加</span>
						<span v-if="data.kinds == 2">不叠加</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="活动时间"
					width="300"
				>
					<template v-slot="{data}">{{data.begin_date}} 至 {{data.end_date}}</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="row">
						<c-table-button @click="navigateTo(`/global_reward_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button power="b_global_reward_edit" v-if="row.data.state == 2 && row.data.start_state != 2" @click="changeState(row,1)">禁用</c-table-button>
                        <c-table-button power="b_global_reward_edit" v-if="row.data.state == 1 && row.data.start_state != 2" @click="changeState(row,2)">启用</c-table-button>
                        <c-table-button power="b_global_reward_edit" v-if="row.data.state == 1 || row.data.start_state != 2" @click="navigateTo(`/global_reward_edit/${row.data.id}`)">修改</c-table-button>
                        <c-table-button power="b_global_reward_edit" v-if="row.data.state == 1 || row.data.start_state == 2" @click="deletea(row)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_global_reward',
		
		data() {
			return {
				activityState: [{
						name: '未开始',
						value: 0
					}, {
						name: '进行中',
						value: 1
					}, {
						name: '已结束',
						value: 2
					}
				],
				//是否启用1（停用）2（启用）
				stateName: [{
						name: '停用',
						value: 1
					}, {
						name: '启用',
						value: 2
					}
				]
			}
		},
		
		computed: {
			stateText() {
				var state = {};
				this.activityState.forEach(item => {
					state[item.value] = item.name;
				});
				
				return state;
			}
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('globalRewardList.update', () => {
				this.$refs.search.search();
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/globalReward/list',
					data
				});
			},
			//启禁用
			changeState(item,state) {
				this.$confirm({
					text: '确定要'+(state==2?"启用":"禁用")+'活动【'+item.data.name+'】吗？',
					resolve: () => {
						this.request({
							url: '/globalReward/updateState',
							data: {
								id: item.data.id,
								state:state
							},
							loading: true,
							success: () => {
								this.$message({
									text: '操作成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			//删除
			deletea(item) {
				this.$confirm({
					text: '确定要删除此活动【'+item.data.name+'】吗？',
					resolve: () => {
						this.request({
							url: '/globalReward/delete',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									icon: 'success',
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			}
		}
	}
</script>